import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from "../../components/misc/Headings.js";
import { SectionDescription } from "../../components/misc/Typography.js";
import { PrimaryButton as PrimaryButtonBase } from "../../components/misc/Buttons.js";
import {
  Container,
  ContentWithPaddingXl,
} from "../../components/misc/Layouts.js";
import { ReactComponent as SvgDecoratorBlob1 } from "../../images/svg-decorator-blob-6.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "../../images/svg-decorator-blob-7.svg";

const HeaderContainer = tw.div`w-full flex flex-col items-center`;
const Subheading = tw(SubheadingBase)`mb-4`;
const Heading = tw(SectionHeading)`w-full`;
const Description = tw(SectionDescription)`w-full text-center`;

const PricingContainer = tw.div`flex justify-center items-center mt-16`;
const PricingCard = tw.div`w-full max-w-lg text-center px-8 py-12 rounded-lg bg-white shadow-raised relative`;

const PricingMessage = tw.div`text-lg text-gray-700 mb-8`;
const ContactButton = tw(PrimaryButtonBase)`mt-4`;

const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none -z-20 absolute left-0 bottom-0 h-64 w-64 opacity-15 transform -translate-x-2/3 -translate-y-1/2`}
`;
const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
  ${tw`pointer-events-none -z-20 absolute right-0 top-0 h-64 w-64 opacity-15 transform translate-x-2/3 translate-y-1/2`}
`;

export default ({
  subheading = "Pricing",
  heading = "Flexible Pricing Plans",
  description = "Reach out to us for pricing details.",
  onContactClick = () => {},
}) => {
  return (
    <Container>
      <ContentWithPaddingXl>
        <HeaderContainer>
          {subheading && <Subheading>{subheading}</Subheading>}
          <Heading>{heading}</Heading>
          {description && <Description>{description}</Description>}
        </HeaderContainer>

        <PricingContainer>
          <PricingCard>
            <PricingMessage>
              We offer customized pricing solutions tailored to your specific
              needs. Contact us today to discuss the perfect plan for your
              business.
            </PricingMessage>
            <ContactButton onClick={onContactClick}>
              Get Custom Quote
            </ContactButton>
          </PricingCard>
        </PricingContainer>

        <DecoratorBlob1 />
        <DecoratorBlob2 />
      </ContentWithPaddingXl>
    </Container>
  );
};
